import { IsInt, IsNotEmpty } from 'class-validator';

export class OrderDialogStartSessionRequestDto {
  @IsNotEmpty()
  @IsInt()
  orderId: number;

  @IsNotEmpty()
  @IsInt()
  menuId: number;
}